module.exports = __webpack_public_path__ + "img/MaskGroup 2880.ef982502.svg";